import React, { useState, useEffect, useCallback } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import MarkdownView from 'react-showdown';
import theme from 'shared/assets/style/theme';
import { TERMS_TYPE } from 'shared/constants';
import Utils from 'shared/utils';
import AsyncStorage from 'shared/utils/safeAsyncStorageProvider';

export default function TermsAndConditions(props) {
  const {
    termsAndConditions: { data: TCData },
    termsAndConditionsRequestData,
    selectedPropertyTerms,
    playerInfo,
    token,
    docType,
  } = props;

  const [termsText, setTermsText] = useState();
  const [policyText, setPolicyText] = useState();

  const dispatchRequestData = useCallback(async () => {
    const affId = Utils.getPlatform() === 'web' ? playerInfo.aff_id : await AsyncStorage.getItem('aff_id');

    termsAndConditionsRequestData({ token, affId });
  }, [playerInfo.aff_id, termsAndConditionsRequestData, token]);

  useEffect(() => {
    dispatchRequestData();
  }, [dispatchRequestData]);

  useEffect(() => {
    if (selectedPropertyTerms) getFiles(selectedPropertyTerms);
    else TCData.length !== 0 && getFiles(TCData);
  }, [TCData, selectedPropertyTerms]);

  const getFiles = texts => {
    fetch(texts.termsAndConditions)
      .then(response => response.text())
      .then(result => {
        setTermsText(result);
      })
      .catch(e => {
        console.log(e);
      });

    fetch(texts.privacyPolicy)
      .then(response => response.text())
      .then(result => {
        setPolicyText(result);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const checkScrrenOffset = () => {
    const height = window.innerHeight;
    if (height < 800) return 270;
    if (height < 1100) return 400;
    return 520;
  };

  useEffect(() => {
    checkToShowText();
  }, [termsText, policyText]);

  const checkToShowText = useCallback(() => {
    if (termsText && policyText) {
      if (docType === TERMS_TYPE.POLICY) {
        let bodyRect = document.getElementById('scrollToPrivacy').getBoundingClientRect();
        scrollRef.current.scrollTop(bodyRect.top - checkScrrenOffset());
      }
    }
  }, [policyText, termsText]);

  const scrollRef = React.createRef();

  return (
    <Scrollbars
      className="legalText"
      style={{ height: '21rem' }}
      renderTrackVertical={({ style, ...props }) => (
        <div
          className="ScrollTrack"
          style={{
            ...style,
            top: 8,
            bottom: 8,
            right: 8,
            backgroundColor: theme.palette.common[0],
            width: '0.5rem',
            borderRadius: '8px',
          }}
          {...props}
        />
      )}
      renderThumbVertical={({ style, ...props }) => (
        <div
          className="ScrollThumb"
          style={{
            ...style,
            backgroundColor: theme.palette.primary[10],
            cursor: 'pointer',
            width: '0.5rem',
            borderRadius: '8px',
          }}
          {...props}
        />
      )}
      ref={scrollRef}
    >
      <div className="legalText">
        <MarkdownView markdown={termsText} />
      </div>
      <div id="scrollToPrivacy" className="legalText">
        <MarkdownView markdown={policyText} />
      </div>
    </Scrollbars>
  );
}

